import { render, staticRenderFns } from "./PitchIcon.vue?vue&type=template&id=5254ba9f"
import script from "./PitchIcon.vue?vue&type=script&lang=js"
export * from "./PitchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports